<template>
    <div>
        <div class="d-flex title align-items-center">
            <div class="flex-grow-1">
                {{ item.title }}
            </div>
            <div v-for="sub_url in item.urls" v-bind:key="sub_url.url">
                <a :href="sub_url.url" target="_blank" rel="noopener noreferrer"
                    ><img :src="iconsrc(sub_url)" :alt="sub_url.url"
                /></a>
            </div>
            <div class="mr-2"></div>
        </div>
        <hr class="titleline" />
    </div>
</template>

<script>
export default {
    name: 'AudioButtonsTitle',
    components: {},
    props: {
        item: {
            type: Object,
        },
    },
    computed: {
        iconsrc: function () {
            return function (url) {
                if (url == null) {
                    return ''
                }
                switch (url.channelId) {
                    case 'UCB1s_IdO-r0nUkY2mXeti-A':
                        return require('../assets/reona_80.jpg')
                    case 'UCxJ9SJLG7dA00M7VoEe4ltw':
                        return require('../assets/hano_80.jpg')
                    case 'UCP9ZgeIJ3Ri9En69R0kJc9Q':
                        return require('../assets/chieri_80.jpg')
                    case 'UC3-jXrZXv-PQshpaTQpicPQ':
                        return require('../assets/non_80.jpg')
                    case 'UCUZ5AlC3rTlM-rA2cj5RP6w':
                        return require('../assets/suzu_80.jpg')
                    case 'UCz6Gi81kE6p5cdW1rT0ixqw':
                        return require('../assets/mememe_80.jpg')
                    case 'UCtM5G3bS7zM8bv6p-OwoNTw':
                        return require('../assets/rikumu_80.jpg')
                    case 'UCSlcMof1GIPvH6H_VcknCbQ':
                        return require('../assets/milily_80.jpg')
                    default:
                        break
                }

                if (url.site === 'youtube') {
                    return require('../assets/youtube_logo_80.png')
                } else if (url.site === 'mildom') {
                    return require('../assets/mildom_logo_80.png')
                } else {
                    return require('../assets/youtube_logo_80.png')
                }
            }
        },
    },
}
</script>

<style scoped>
.title {
    font-size: medium;
    padding-top: 0.5rem;
    margin: 0px 10px;
    color: white;
}
.titleline {
    height: 1px;
    background: linear-gradient(
        to right,
        rgba(138, 72, 133, 1),
        rgba(138, 72, 133, 0.1)
    );
    border: none;
    margin: 0px 10px;
}
.title img {
    width: 30px;
    height: 30px;
}
</style>